var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    class: {
      'mr-3 captureButton': _vm.$vuetify.breakpoint.mdAndUp,
      'mb-3 captureButton': _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "color": "pink darken-2"
    },
    on: {
      "click": function click($event) {
        _vm.cameraDialog = true;
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "white"
    }
  }, [_vm._v("photo_camera")]), _c('div', {
    staticClass: "title text-xs-center"
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.takePhoto')) + "\n      ")])], 1)], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.cameraDialog,
      callback: function callback($$v) {
        _vm.cameraDialog = $$v;
      },
      expression: "cameraDialog"
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('v-toolbar', {
    staticClass: "ml-3",
    attrs: {
      "color": "white",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function click($event) {
        _vm.cameraDialog = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("arrow_back")]), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1)], 1), !_vm.photoTaken ? _c('video', {
    ref: "video",
    staticClass: "mt-3",
    class: {
      flash: _vm.flashOn
    }
  }) : _vm._e(), _vm.photoTaken ? _c('v-img', {
    staticClass: "mt-3",
    attrs: {
      "src": _vm.src,
      "aspect-ratio": "1"
    }
  }) : _vm._e(), !_vm.isCameraReady ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm.photoTaken ? _c('v-btn', {
    nativeOn: {
      "click": function click($event) {
        _vm.photoTaken = false;
      }
    }
  }, [_c('span', [_vm._v("Retake")])]) : _vm._e(), _vm.photoTaken ? _c('v-btn', {
    attrs: {
      "color": "green",
      "loading": _vm.saving
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.savePhoto.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("save")]), _c('span', [_vm._v("Save")])], 1) : _vm._e(), _vm.media == 'photo' && _vm.isCameraReady && _vm.photoTaken == false ? _c('v-card', {
    class: {
      'mr-3 mt-3 captureButton': _vm.$vuetify.breakpoint.mdAndUp,
      'mb-3 mt-3 captureButton': _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "color": "pink darken-2"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.capture.apply(null, arguments);
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("photo_camera")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.takePicture')) + "\n          ")])], 1)], 1) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }